import { Component, Vue, Ref } from "vue-property-decorator";
import InnerBody from './components/InnerBody'
import InnerBodys from './components/InnerBodys'
import CreatModal from './components/CreatModal.vue'
import { StockOutOrderServiceProxy,StockOutOrderMaterialServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'
import { WarehouseAreaServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'
import { EmployeeSearchDTO, EmployeeServiceProxy } from '@/service-proxies/app-v2/employee.service-proxies'
import { AuthorityDomainServiceProxy } from '@/service-proxies/app-v2/system.service-proxies';
import CodeModel from '@/components/CodeModel/index.vue'

const esp = new EmployeeServiceProxy()
const soosp = new StockOutOrderServiceProxy()
const wasp = new WarehouseAreaServiceProxy()
const soomsp = new StockOutOrderMaterialServiceProxy()
const adsp = new AuthorityDomainServiceProxy()
@Component({
  components: {
    InnerBody,
    InnerBodys,
    CreatModal,
    CodeModel
  }
})
export default class Alarm extends Vue {
  dataOutOrder = [] // 出库单物料
  OrderMaterialList = [] // 出库单物料列表
  selectedRowKeys = []
  addNewVisible = false
  searchKey = ""
  paginationOrder = {
    pageSize: 10,
    current: 1,
  }
  total = 0
  height = 300
  orderLoading = false
  listWare = []
  orderMaterialLoading = false
  materialId = ""
  employeesList = []
  treeList = []
  listAllTree = []
  selectId = ""
  resizeTimer = null
  tableScrollHeight = 300
  printVisible = false
  dataList = []

  mounted() {
    this.$nextTick(() => {
      this.materialId = (this.$route.query.materialId ? this.$route.query.materialId : 0).toString()
      this.getList()
      wasp.listWarehouseArea('').then(res =>{
        this.listWare = res
      })
      esp.getPageEmployees(1,{statusList: [1]} as EmployeeSearchDTO,"",999999).then(res =>{
        this.employeesList = res.records
      })
      adsp.treeList().then(res =>{
        const arr:any = res.data
        arr.forEach(item => {
          this.treeList.push(this.filterData(item))
        })
      })
    })
  }

  filterData(item: any) {
    const arr = {
      title: item.title,
      value: item.id,
      key: item.id,
      children: [],
    }
    this.listAllTree.push(arr)
    if (item.children && item.children.length > 0) {
      item.children.forEach(res =>{
        arr.children.push(this.filterData(res))
      })
    } else {
      delete item.children;
    }
    return arr;
  }

  getList(){
    this.orderLoading = true
    soosp.pageStockOutOrder(this.materialId,this.paginationOrder.current,this.searchKey,this.paginationOrder.pageSize).then(res =>{
      this.dataOutOrder = res.records
      // console.log(22222222222,this.dataOutOrder)
      if(res.records && res.records.length > 0){
        this.onClickRow(res.records[0].id)
      }
      this.total = Number(res.total)
      this.orderLoading = false
    }).catch(() =>{
      this.orderLoading = false
    })
  }

  reload(){
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.addNewVisible = false
    this.getList()
  }

  updated(){
    const div = document.body.clientHeight
    this.tableScrollHeight = (div - 360) /2
    this.height = (div - 350) /2
  }
  
  delete(){
    
  }
  
  onSearch(value) {
    this.paginationOrder = {
      pageSize: 10,
      current: 1
    }
    this.searchKey = value
    this.getList()
  }
  
  addNew(){
    this.addNewVisible = true
  }

  addClose(){
    this.addNewVisible = false
  }

  onSelectChange(selectedRowKeys) {
    this.selectedRowKeys = selectedRowKeys;
    if(selectedRowKeys.length == 1 ){
      this.onClickRow(selectedRowKeys[0])
    }
  }

  handleTableChange(data) {
    this.paginationOrder = {
      pageSize: data.pageSize,
      current: data.current
    }
    this.getList()
  }

  onClickRow(value){
    this.selectId = value
    this.selectedRowKeys = [value]
    this.orderMaterialLoading = true
    soomsp.listStockOutOrderMaterial(value).then(res =>{
      this.OrderMaterialList = res
      this.orderMaterialLoading = false
    })
  }
    
  beforeDestroy(){
    clearTimeout(this.resizeTimer)
  }

  changeY(){
    if(this.resizeTimer){
      clearTimeout(this.resizeTimer);
    }
    this.resizeTimer = setTimeout(function(){
      const div = document.getElementById('ware-topmodal')
      this.tableScrollHeight = div.clientHeight
      const bodyTableBody: any = document.querySelector('#ware-topmodal .ant-table-body')
      if(bodyTableBody){
        bodyTableBody.style.maxHeight = (this.tableScrollHeight - 88) + 'px'
      }
    },100)
  }
  printing() {
    this.getData()
    this.printVisible = true
  }

  cancel() {
    this.selectedRowKeys = []
    this.printVisible = false
  }
  handlerPrint() {
    this.selectedRowKeys = []
    this.printVisible = false
  }

  getData() {
    this.dataList = []
    this.selectedRowKeys.map(id =>{
      this.dataOutOrder.map(item => {
        if(id === item.id) {
          this.dataList.push({
            code: item.orderCode,
            name: item.orderName
          })
        }
      })
    })
  }
  
  render() {
    return (
      <blank-view mainStyle={{ 'background': "transparent", 'box-shadow': "none"}}>
        <div slot={'action'} style="display:flex;justify-content: space-between">
          <div>
            <a-button type="primary" onClick={() => this.addNew()} style="margin-right: 8px;">{ this.$t('page_material_ware_out_creat')}</a-button>
            {/* <a-button type="danger" onClick={() => this.delete()} disabled={this.selectedRowKeys.length === 0} style="margin-right: 8px;">{ this.$t('delete') }</a-button> */}
            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_workstation_maintain_inport_model')}</a-button>
            <a-button type="default" disabled={this.selectedRowKeys.length === 0} style="margin-right: 8px;">{this.$t('page_import_export')}</a-button> */}
            <a-button type="default" disabled={this.selectedRowKeys.length === 0} style="margin-right: 8px;" onClick={() =>this.printing()}>{this.$t("page_print_code")}</a-button>
          </div>
          <div>
            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_my_document_advanced') }</a-button> */}
            <a-input-search placeholder={this.$t('keyword')} style="width: 200px" enterButton={this.$t('search')} onSearch={value => this.onSearch(value)} />
          </div>
        </div>
        <div id="inner" style="height:100%">
          <div id="ware-topmodal" style="width:100%;height: calc(50% - 4px);position: relative;box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);background-color: #fff;overflow:auto">
            <inner-body
              height={this.tableScrollHeight}
              selectId={this.selectId}
              selectedRowKeys={this.selectedRowKeys}
              listAllTree={this.listAllTree}
              employeesList={this.employeesList}
              data={this.dataOutOrder}
              current={this.paginationOrder.current}
              total={this.total}
              loading={this.orderLoading}
              pageSize={this.paginationOrder.pageSize}
              onOnSelectChange={value => this.onSelectChange(value) }
              onHandleTableChange={value => this.handleTableChange(value) }
              onClickRow={value => this.onClickRow(value) }></inner-body>
          </div>
          <div v-resize={{axis: 'y', cb: this.changeY }}></div>
          <div style="width:100%;height: calc(50% - 4px);position: relative;box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);background-color: #fff;overflow:auto">
            <inner-bodys
              height={this.height}
              data={this.OrderMaterialList}
              loading={this.orderMaterialLoading}
            ></inner-bodys>
          </div>
        </div>
        {this.addNewVisible ? <creat-modal treeList={this.treeList} employeesList={this.employeesList} areaId={this.materialId} visible={this.addNewVisible} listWare={this.listWare} onClose={() => this.addClose()} onReload={() => this.reload()}></creat-modal> : null }
        <code-model
        visible={this.printVisible}
        onCancel={this.cancel}
        dataList={this.dataList}
        onprint={this.handlerPrint}
        >
        </code-model>
      </blank-view>
    )
  }
}
